import { render, staticRenderFns } from "./paparMaklumat.vue?vue&type=template&id=bc965f3a&scoped=true&"
import script from "./paparMaklumat.vue?vue&type=script&lang=js&"
export * from "./paparMaklumat.vue?vue&type=script&lang=js&"
import style0 from "./paparMaklumat.vue?vue&type=style&index=0&id=bc965f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc965f3a",
  null
  
)

export default component.exports